import { Button, Css, Icon, IconProps, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { ReactNode, useCallback } from "react";

export type ConfirmationModalProps = {
  confirmationMessage: ReactNode | string;
  onConfirmAction: () => void;
  closeOnConfirm?: boolean;
  title: string;
  label: string;
  danger?: boolean;
  disabled?: boolean | ReactNode;
  icon?: IconProps;
};

export function ConfirmationModal(props: ConfirmationModalProps) {
  const { confirmationMessage, onConfirmAction, title, label, danger, disabled, icon, closeOnConfirm = true } = props;
  const { closeModal } = useModal();

  const onConfirmClick = useCallback(async () => {
    await onConfirmAction();
    if (closeOnConfirm) closeModal();
  }, [onConfirmAction, closeOnConfirm, closeModal]);

  const renderBody = () => {
    if (typeof confirmationMessage === "string") {
      return <p css={Css.sm.gray900.mb2.$}>{confirmationMessage}</p>;
    } else {
      return confirmationMessage;
    }
  };

  return (
    <>
      <ModalHeader>
        <span css={Css.df.aic.gap1.$}>
          {icon && <Icon {...icon} />}
          {title}
        </span>
      </ModalHeader>
      <ModalBody>{renderBody()}</ModalBody>
      <ModalFooter>
        <Button variant="quaternary" label="Cancel" onClick={closeModal} />
        <Button disabled={disabled} label={label} onClick={onConfirmClick} variant={!!danger ? "danger" : "primary"} />
      </ModalFooter>
    </>
  );
}
